<template>
  <div class="flex">
    <div @click="$emit('openPlace', place)" class="flex px-2 py-3 h-18">
      <div class="flex-none w-36">
        <progressive-img
          :src="place.image"
          :fallback="require('@/assets/images/no-image.jpg')"
          class="w-full h-24"
        />
      </div>
      <div class="flex-grow ml-2">
        <h2 class="font-bold">{{ place.name }}</h2>
        <p class="text-sm">{{ place.address }}</p>
        <p v-for="benefit in place.benefits" v-bind:key="benefit.id"
          class="inline-block mt-1 py-1 px-2 border rounded text-sm leading-none border-pass text-pass">
          {{ benefit.name }}
        </p>
      </div>
    </div>
    <div v-if="token" class="m-2">
      <favorite :place="place" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Favorite from '../../molecules/Favorite'

export default {
  components: {
    Favorite
  },
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/getToken'
    })
  }
}
</script>
